import {Flash} from '@primer/react'
import {InfoIcon} from '@primer/octicons-react'
import {PUSH_RULESET_TARGET_INFO} from '../../helpers/constants'

export const PushRulePublicTargetingBanner = () => {
  return (
    <Flash>
      <div className="d-flex flex-row flex-items-center">
        <InfoIcon />
        <span>{PUSH_RULESET_TARGET_INFO}</span>
      </div>
    </Flash>
  )
}
